import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable, from} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BiosphereService {

    configBiometricos: any;
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
    }

    public invokeBioSphere(request: any, biosphereConfig: any): Observable<any> {
      let headers: any = new Headers();
      headers.append('Content-Type', 'application/json');
        const requestOptions: any = {
            method: 'POST',
            headers: headers,
            body: request,
            redirect: 'follow'
        };
        console.debug("biometricosPost")
        console.debug(request)
        const biometricosPost = new Promise(function (resolve, reject) {
            try {
                fetch(biosphereConfig?.bioSphereClientUrl, requestOptions)
                .then(response => {
                    if (!response.ok) {
                        console.debug('Error de comunicación con BioSphere Client', true);
                        resolve({
                            resultado: 0,
                        });
                    }
                    return response.json();
                }).then(result => {
                    resolve(result);
                })
                .catch(error => {
                    resolve({
                        resultado: 0,
                    });
                });
            } catch (e: any) {
                resolve({
                    resultado: 0,
                });
            }
            });
        return from(biometricosPost).pipe(map((x) => x));
            //Version anterior
      // return this._httpClient.post<any>(
      //         this.configBiometricos?.biosphere?.bioSphereClientUrl,
      //         request,
      //         headers,
      //     ).pipe(
      //     map((response: any) => response));
    }

    public calculateSignature(clientSecret: any, payloadJson: any) {
        const combinedString = clientSecret + payloadJson;
        const utf8EncodedString = new TextEncoder().encode(combinedString);
        const hashBuffer = crypto.subtle.digest("SHA-256", utf8EncodedString);
        const signature = new Promise((resolve, reject) => {
            hashBuffer.then(buffer => {
                const hashArray = Array.from(new Uint8Array(buffer));
                const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, "0")).join("");
                resolve(hashHex);
            }).catch(error => {
                reject(error);
            });
        });

        return from(signature).pipe(map((x) => x));
      }
}
